import { render } from "./ActivitatFormacioView.vue?vue&type=template&id=8c477008&scoped=true"
import script from "./ActivitatFormacioView.vue?vue&type=script&lang=js"
export * from "./ActivitatFormacioView.vue?vue&type=script&lang=js"

import "./ActivitatFormacioView.vue?vue&type=style&index=0&id=8c477008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c477008"]])

export default __exports__